module.exports = __webpack_public_path__ + "img/375_img6.308675fa.png";